<template>
    <b-modal id="editModal" ref="modal" :title="title" :centered="true" :visible="open" @hide="modalEvent(false)"  
    ok-title="Kaydet" cancel-title="Vazgeç" size="xl" @ok="saveModal" scrollable>
            <component v-bind:is="renderModalForm" :data="modalProps" ref="Report"></component>
    </b-modal>
</template>

<script>
    import ExcelReport from "./ExcelReport"
    import PdfReport from "./PdfReport"
    import pdfMake from "pdfmake/build/pdfmake";
    import pdfFonts from "pdfmake/build/vfs_fonts";
    import Logo from "@/assets/img/sanatLogo.png"
    import  reportData  from '../pdf/pdf';
    export default {
        name: 'Modal',
        data: function(){
            return{
                title: '',
            }
        },
        props:{
            open: Boolean,
            modalEvent: Function,
            form: String,
            modalName: String,
            modalProps: Object
        },
        components:{
            ExcelReport, PdfReport
        },
        computed:{
            //Açılacak Modalı belirleme işlemleri
            renderModalForm: function(){
                switch(this.form){
                   case 'Reports':
                       switch(this.modalName){
                            case "excel":
                                this.title = "Excel Raporu"
                                return "ExcelReport"
                            case "pdf":
                                this.title = "PDF Raporu"
                                return "PdfReport"
                        }
                    break;
                }
            }
        },
        methods:{
            // Modal tamamlandığı zaman olacak event
            saveModal: function(){
                if(this.modalName){
                    var docDefinition = reportData(Logo)
                    for(let i = 0; i < this.modalProps.length; i++){
                    docDefinition.content[2].table.body.push([
                            { text: this.modalProps[i].name, alignment: 'center' },
                            { text: this.modalProps[i].idNo, alignment: 'center' },
                            { text: this.modalProps[i].address, alignment: 'center' },
                            { text: this.modalProps[i].city, alignment: 'center'},
                            { text: this.modalProps[i].district, alignment: 'center' },
                            { text: this.modalProps[i].camera, alignment: 'center' },
                            { text: this.modalProps[i].alarm, alignment: 'center' },
                            { text: this.modalProps[i].account, alignment: 'center' },
                            { text: this.modalProps[i].date, alignment: 'center' },   
                        ])
                    }
                
                    pdfMake.vfs = pdfFonts.pdfMake.vfs;
                    pdfMake.createPdf(docDefinition).download('optionalName.pdf'); 
                    }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/General/Reports/modals/index.vue